import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { filter, find, includes, map, setWith, compact, get, findIndex, isEmpty, omit } from 'lodash'
import { Tabs, Tab } from 'react-bootstrap'

import { objectToOptions } from "Utilities/selectOptions"
import axios from "lib/axios"
import Table from 'UI/Table'
import { Filters, defaultFilters } from '../Filters'
import { filteredCustomers, filteredVMs, tabTitles } from '../Data'
import { TableHeaders } from './TableHeaders'

const submitSpla = ({ splaToSubmit }) => {
  const url = '/assets/cloudcore/spla/editor'


  const patchValues = {
    update: omit(splaToSubmit, ['create']),
    create: get(splaToSubmit, 'create')
  }

  axios.patch(url, patchValues)
    .then((response) => { window.location.href = url })
    .catch((e) => {
      console.log(e)
    })
}

const getBundleIdsFromTitle = title => map(find(tabTitles, ['title', title]).bundle_ids, id => ({ value: `vm_product_${id}` }))
const VmSplaEditor = ({ spla, productTableHeaders, locations }) => {
  const [splaToSubmit, updateSpla] = useState({})
  const [splaRecordsForTable, updateSplaRecordsForTable] = useState(spla)
  const [currentTab, setCurrentTab] = useState('Exchange')
  const [filters, changeFilters] = useState({ ...defaultFilters, products: getBundleIdsFromTitle(currentTab) })

  const currentTableHeaders = filter(productTableHeaders, header => includes(map(filters.products, 'value'), header.accessor))
  const updateSplaRecords = ({ id, field, value, customerId, vmId, productKey, action = 'update' }) => {
    if (action == 'create') {
      const currentValues = get(splaToSubmit, `create.${id}`)
      setWith(splaToSubmit, `create.${id}`, { ...currentValues, [field]: value }, Object)
    } else {
      const currentValues = get(splaToSubmit, id)
      setWith(splaToSubmit, id, { ...currentValues, [field]: value }, Object)
    }

    const customerIndex = findIndex(splaRecordsForTable, ['customer_id', customerId])
    const vmIndex = findIndex(splaRecordsForTable[customerIndex].vms, ['vm_id', vmId])
    const currentValues = get(splaRecordsForTable, `[${customerIndex}].vms[${vmIndex}].${productKey}`)
    setWith(splaRecordsForTable, `[${customerIndex}].vms[${vmIndex}].${productKey}`, { ...currentValues, [field]: value }, Object)

    updateSplaRecordsForTable([...compact(splaRecordsForTable), null])
    updateSpla(splaToSubmit)
  }

  return (
    <Fragment>
      <Filters {...{ filters, changeFilters, customers: objectToOptions(spla, 'customer_id', 'customer_name'), locations, hideProductFilter: true }} />
      <button className="btn btn-primary" onClick={() => submitSpla({ splaToSubmit })} disabled={isEmpty(splaToSubmit)}>Submit</button>

      <Tabs id="cloudcore-spla-editor" activeKey={currentTab} onSelect={newTab => { setCurrentTab(newTab); changeFilters({ ...filters, products: getBundleIdsFromTitle(newTab) }) }}>
        {map(tabTitles, ({ title, licenseTypes }) => (
          <Tab eventKey={title} title={title}>
            {currentTab === title && (
              <Table {...{
                data: filteredCustomers({ customers: splaRecordsForTable, filters }),
                defaultSorted: [{ id: "customer_name", asc: true }],
                className: "-highlight -allow-overflow",
                filterable: true,
                columns: [
                  { Header: 'Customer', accessor: 'customer_name', Footer: () => <strong>Totals: </strong> },
                  ...TableHeaders({ headers: currentTableHeaders })
                ],
                collapseOnDataChange: false,
                SubComponent: (row) => (
                  <Table {...{
                    data: filteredVMs({ vms: row.original.vms, filters }),
                    defaultSorted: [{ id: "vm_name", asc: true }],
                    pageSize: row.original.vms.length,
                    showPagination: false,
                    className: "-highlight -striped -allow-overflow",
                    filterable: false,
                    collapseOnDataChange: false,
                    columns: [
                      { Header: 'Name', accessor: 'vm_name', minWidth: 180, Footer: () => <strong>Totals: </strong> },
                      ...TableHeaders({
                        headers: currentTableHeaders,
                        editable: true,
                        licenseTypes,
                        updateSplaRecords
                      })
                    ],
                  }} />
                )
              }} />
            )}
          </Tab>
        ))}
      </Tabs>
    </Fragment>
  )
}

VmSplaEditor.propTypes = {

}

export default VmSplaEditor
